/* @flow */

import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import TimelineRegular from './timeline-regular-icon.svg';

function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <TimelineRegular {...validProps} />;
}
SvgComponent.iconName = 'timelineRegular';

export const TimelineRegularIcon = svgIconWrapper(SvgComponent);
